module.exports = __webpack_public_path__ + "static/media/icon-local-delivery.541c81ff.svg";